export const PARAM_TABLE = "table";
